import { Button } from "@appcharge/shared-ui";
import { ColumnDef } from "@tanstack/react-table";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { TableCellEllipsis } from "components/Orders/Orders/Components/TableCellEllipsis";

import { PayoutTableRow } from "../types/payouts.types";

dayjs.extend(utc);

export const PAYOUTS_TABLE_COLUMNS = (
  onDownloadClick: (payoutId: string, publisherId?: string, period?: string) => void
): ColumnDef<PayoutTableRow>[] => [
    {
      accessorKey: 'reference',
      header: 'Transfer Reference',
      cell: ({ getValue }) => <TableCellEllipsis>{getValue() as string}</TableCellEllipsis>,
      enableSorting: true
    },
    {
      accessorKey: 'transferDate',
      header: 'Transfer Date',
      cell: ({ getValue }) => <TableCellEllipsis>{dayjs.utc(getValue() as Date).format('MMM DD, YYYY')}</TableCellEllipsis>,
      enableSorting: true,
      sortDescFirst: true
    },
    {
      accessorKey: 'amount',
      header: 'Amount',
      cell: ({ getValue }) => <TableCellEllipsis>{(getValue() as number).toLocaleString()}</TableCellEllipsis>,
      enableSorting: true,
      sortDescFirst: true
    },
    {
      accessorKey: 'currency',
      header: 'Currency',
      cell: ({ getValue }) => <TableCellEllipsis>{getValue() as string}</TableCellEllipsis>,
      enableSorting: true
    },
    {
      accessorKey: 'periodStart',
      header: 'Period',
      cell: ({ row }) => {
        const period = `${dayjs.utc(row.original.periodStart).format('MMM DD, YYYY')} - ${dayjs.utc(row.original.periodEnd).format('MMM DD, YYYY')}`;
        return <TableCellEllipsis>{period}</TableCellEllipsis>;
      },
      enableSorting: true
    },
    {
      accessorKey: '_id',
      header: 'Download Report',
      cell: ({ row }) => {
        const period = `${dayjs.utc(row.original.periodStart).format('DD/MM/YY')} - ${dayjs.utc(row.original.periodEnd).format('DD/MM/YY')}`;
        return (
          <Button
            variant="outline"
            onClick={(e) => {
              e.stopPropagation();
              onDownloadClick(row.original._id, row.original.publisherId, period);
            }}
          >
            Download
          </Button>
        );
      }
    },
  ];

export const PAYOUT_TABLE_ROWS_PER_PAGE = 200;

